<script setup>
import { onMounted, onUnmounted } from 'vue';
import { languages } from '~/assets/jsons/languages.json';
const { locale, locales, setLocale } = useI18n();

const languagePanel = ref(false);

const language = computed({
  get: () => locale.value,
  set: value => setLocale(value),
});

const switchLanguage = async newLocale => {
  languagePanel.value = false;
  await setLocale(newLocale);
};

const toggle = (event) => {
  event.stopPropagation();
  languagePanel.value = !languagePanel.value;
};

const clickOutsideHandler = ref(null);

onMounted(() => {
  clickOutsideHandler.value = (event) => {
    const dropdown = document.querySelector('.language-dropdown');
    if (dropdown && !dropdown.contains(event.target)) {
      languagePanel.value = false;
    }
  };
  
  nextTick(() => {
    document.addEventListener('click', clickOutsideHandler.value);
  });
});

onUnmounted(() => {
  if (clickOutsideHandler.value) {
    document.removeEventListener('click', clickOutsideHandler.value);
  }
});
const route = useRoute()
</script>

<template>
  <ClientOnly>
    <div class="relative flex items-center justify-center language-dropdown">
      <PrimeButton
      :label="languages[language]"
      icon="pi pi-language"
      @click="toggle"
      text
      severity="contrast"
      class="px-2 py-1 focus:shadow-none"
      size="small"
      />
      <div v-show="languagePanel" class="absolute top-full mt-2 max-lg:left-0 shadow-lg rounded-md py-2 px-3 z-[9999] w-fit max-h-[250px] overflow-y-auto bg-[var(--p-background-0)] custom-scrollbar">
        <div class="flex flex-col gap-2">
          <div v-for="currentLocale in locales" :key="currentLocale.code" class="flex items-center py-1 rounded px-2 gap-2">
            <PrimeRadioButton
              v-model="language"
              :inputId="currentLocale.code"
              name="language"
              :value="currentLocale.code"
              @click="switchLanguage(currentLocale.code)"
              severity="contrast"
            />
            <label :for="currentLocale.code" @click="switchLanguage(currentLocale.code)" class="ml-2 cursor-pointer">
              {{ languages[currentLocale.name] }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </ClientOnly>
</template>

<style scoped>
/* Basic scrollbar settings */
.custom-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: #d1d5db #f3f4f6 !important;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
  overflow-scrolling: touch; /* Future-proofing */
}

/* Force scrollbar visibility on all devices */
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
  -webkit-appearance: none;
  display: block; /* Force display on mobile */
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: #f3f4f6;
  border-radius: 10px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 10px;
  min-height: 40px; /* Ensure thumb is visible */
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #d1d5db;
}
</style>
